import React from 'react';

const STATS = [
  { num: '3+', label: 'Years Advising' },
  { num: '100+', label: 'Clients Served' },
  { num: '₹50L+', label: 'Assets Under Advisory' }
];

export const HeroStats = () => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
      gap: '2rem',
      maxWidth: '780px',
      margin: '0 auto'
    }}
  >
    {STATS.map((s) => (
      <div key={s.label} style={{ textAlign: 'center' }}>
        <div
          style={{
            fontSize: '2.25rem',
            fontWeight: 700,
            color: 'var(--accent-gold)',
            marginBottom: '0.35rem',
            fontVariantNumeric: 'tabular-nums'
          }}
        >
          {s.num}
        </div>
        <div style={{ fontSize: '0.875rem', color: 'rgba(255,255,255,0.78)', fontWeight: 500 }}>
          {s.label}
        </div>
      </div>
    ))}
  </div>
);
